'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var PropTypes = require('prop-types');
var cx = require('classnames');
var FocusLock = require('react-focus-lock');
var Popover = require('@arrive/popover');
var Checkbox = require('@arrive/checkbox');
var SVGIcon = require('@arrive/svg-icon');
var ApplyButtonBar = require('@arrive/apply-button-bar');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
var cx__default = /*#__PURE__*/_interopDefaultLegacy(cx);
var FocusLock__default = /*#__PURE__*/_interopDefaultLegacy(FocusLock);
var Popover__default = /*#__PURE__*/_interopDefaultLegacy(Popover);
var Checkbox__default = /*#__PURE__*/_interopDefaultLegacy(Checkbox);
var SVGIcon__default = /*#__PURE__*/_interopDefaultLegacy(SVGIcon);
var ApplyButtonBar__default = /*#__PURE__*/_interopDefaultLegacy(ApplyButtonBar);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var styles = {"ethanol":"#fff","tandem":"#f4f5f5","chrome":"#d4d6d9","LFGray":"#9ea2a9","smokey":"#60646c","burnout":"#46494f","roadhog":"#303236","axle":"#1d1e20","grease":"#0a0a0b","bandit":"#e0f3fb","bigSky":"#b1e1f5","arrive":"#2aaae2","blueBayou":"#039ddd","nightTime":"#007dbc","blueridge":"#0062c0","gasoline":"#feefcb","diesel":"#f1ae11","mileMarker":"#e8f5e9","gatorguts":"#4caf50","frogger":"#2b731a","whoaNelly":"#ffedf1","jackknife":"#cb2024","defaultListContainer":"arrive_ListPopover__defaultListContainer","darkMode":"arrive_ListPopover__darkMode","icon":"arrive_ListPopover__icon","listItem":"arrive_ListPopover__listItem","listItemDisabled":"arrive_ListPopover__listItemDisabled","contentContainer":"arrive_ListPopover__contentContainer","iconSpace":"arrive_ListPopover__iconSpace"};

var _excluded = ["classes", "children", "listItems", "matchAnchorWidth", "placement", "showPopover", "setShowPopover", "focusLockProps", "useApplyFooter", "disableApply", "disableClear", "onApplyClick", "onClearClick", "title", "screenSizeSmall", "listPrefix", "theme", "loadingContent", "id"],
    _excluded2 = ["children", "className", "icon", "iconClass", "isDisabled", "isFocusedItem", "keepIconSpace", "onClick", "showIcon", "withCheckbox"];
var ListPopover = /*#__PURE__*/React__default["default"].forwardRef(function (_ref, ref) {
  var _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? {} : _ref$classes,
      children = _ref.children,
      listItems = _ref.listItems,
      _ref$matchAnchorWidth = _ref.matchAnchorWidth,
      matchAnchorWidth = _ref$matchAnchorWidth === void 0 ? false : _ref$matchAnchorWidth,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? "auto" : _ref$placement,
      showPopover = _ref.showPopover,
      setShowPopover = _ref.setShowPopover,
      _ref$focusLockProps = _ref.focusLockProps,
      focusLockProps = _ref$focusLockProps === void 0 ? {} : _ref$focusLockProps,
      useApplyFooter = _ref.useApplyFooter,
      disableApply = _ref.disableApply,
      disableClear = _ref.disableClear,
      onApplyClick = _ref.onApplyClick,
      onClearClick = _ref.onClearClick,
      title = _ref.title,
      screenSizeSmall = _ref.screenSizeSmall,
      listPrefix = _ref.listPrefix,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? "ethanol" : _ref$theme,
      loadingContent = _ref.loadingContent,
      id = _ref.id,
      rest = _objectWithoutProperties(_ref, _excluded);

  var resolvedClasses = _objectSpread2({
    anchorClass: cx__default["default"](classes && classes.anchorClass)
  }, classes);

  var totalItems = React__default["default"].Children.count(listItems);

  var _useState = React.useState(-1),
      _useState2 = _slicedToArray(_useState, 2),
      focusedItem = _useState2[0],
      setFocusedItem = _useState2[1];

  var scrollableSection = React.useRef();
  React.useEffect(function () {
    var listener = function listener(evt) {
      if (focusedItem === -1 && (evt.keyCode === 40 || evt.keyCode === 38)) {
        setFocusedItem(0);
      } else {
        // hit the down arrow
        if (evt.keyCode === 40) {
          evt.stopPropagation();
          evt.preventDefault();
          var newFocusedItem = focusedItem === totalItems - 1 ? 0 : focusedItem + 1;
          setFocusedItem(newFocusedItem);
        } // hit the up arrow


        if (evt.keyCode === 38) {
          evt.stopPropagation();
          evt.preventDefault();

          var _newFocusedItem = focusedItem === 0 ? totalItems - 1 : focusedItem - 1;

          setFocusedItem(_newFocusedItem);
        }
      }
    };

    if (showPopover) {
      document.addEventListener("keydown", listener);
    }

    return function () {
      return document.removeEventListener("keydown", listener);
    };
  }, [focusedItem, setFocusedItem, totalItems, showPopover]);
  React.useEffect(function () {
    if (!showPopover) {
      setFocusedItem(-1);
    }
  }, [showPopover, setFocusedItem]);
  var content = /*#__PURE__*/React__default["default"].createElement(FocusLock__default["default"], _extends({
    autoFocus: false
  }, focusLockProps), /*#__PURE__*/React__default["default"].createElement("div", {
    className: classes.listContainerParent
  }, screenSizeSmall && /*#__PURE__*/React__default["default"].createElement(ApplyButtonBar.ApplyButtonBarMobile, {
    onCancelClick: function onCancelClick(evt) {
      evt.stopPropagation();
      evt.preventDefault();
      setShowPopover(false);
    },
    title: title,
    onApplyClick: onApplyClick,
    theme: theme,
    isApplyButtonDisabled: disableApply,
    isClearButtonDisabled: disableClear
  }), listPrefix && listPrefix, loadingContent ? loadingContent : /*#__PURE__*/React__default["default"].createElement("ul", {
    tabIndex: 0,
    className: cx__default["default"](styles.defaultListContainer, classes && classes.listContainerClass, _defineProperty({}, styles.darkMode, theme === "roadhog")),
    "data-testid": "".concat(id === null || id === void 0 ? void 0 : id.concat('-'), "popper-list-container"),
    ref: scrollableSection
  }, React__default["default"].Children.map(listItems, function (item, idx) {
    return /*#__PURE__*/React__default["default"].cloneElement(item, {
      isFocusedItem: focusedItem === idx
    });
  })), useApplyFooter && !screenSizeSmall && /*#__PURE__*/React__default["default"].createElement(ApplyButtonBar__default["default"], {
    onApplyClick: onApplyClick,
    onClearClick: onClearClick,
    theme: theme,
    isApplyButtonDisabled: disableApply,
    isClearButtonDisabled: disableClear
  })));
  return /*#__PURE__*/React__default["default"].createElement(Popover__default["default"], _extends({
    popperContent: content,
    resolvedClasses: resolvedClasses,
    setShowPopover: setShowPopover,
    showPopover: showPopover,
    matchAnchorWidth: matchAnchorWidth,
    placement: placement,
    screenSizeSmall: screenSizeSmall,
    scrollableChildRef: scrollableSection,
    ref: ref
  }, rest), children);
});
ListPopover.displayName = "ListPopover";
ListPopover.propTypes = {
  classes: PropTypes__default["default"].shape({
    anchorClass: PropTypes__default["default"].string,
    contentContainerClass: PropTypes__default["default"].string,
    listContainerClass: PropTypes__default["default"].string,
    listContainerParent: PropTypes__default["default"].string
  }),
  children: PropTypes__default["default"].oneOfType([PropTypes__default["default"].arrayOf(PropTypes__default["default"].node), PropTypes__default["default"].node]).isRequired,
  listItems: PropTypes__default["default"].oneOfType([PropTypes__default["default"].arrayOf(PropTypes__default["default"].node), PropTypes__default["default"].node]),
  matchAnchorWidth: PropTypes__default["default"].bool,
  placement: PropTypes__default["default"].string,
  showPopover: PropTypes__default["default"].bool.isRequired,
  setShowPopover: PropTypes__default["default"].func.isRequired,
  focusLockProps: PropTypes__default["default"].object,
  useApplyFooter: PropTypes__default["default"].bool,
  onApplyClick: PropTypes__default["default"].func,
  onClearClick: PropTypes__default["default"].func,
  disableApply: PropTypes__default["default"].bool,
  disableClear: PropTypes__default["default"].bool,
  screenSizeSmall: PropTypes__default["default"].bool,
  theme: PropTypes__default["default"].string,
  loadingContent: PropTypes__default["default"].node,

  /**
   * used with screen size small to display in the top bar
   */
  title: PropTypes__default["default"].string
};
var PopoverListItem = /*#__PURE__*/React__default["default"].forwardRef(function (_ref2, ref) {
  var children = _ref2.children,
      className = _ref2.className,
      icon = _ref2.icon,
      iconClass = _ref2.iconClass,
      isDisabled = _ref2.isDisabled,
      isFocusedItem = _ref2.isFocusedItem,
      keepIconSpace = _ref2.keepIconSpace,
      onClick = _ref2.onClick,
      showIcon = _ref2.showIcon,
      withCheckbox = _ref2.withCheckbox,
      rest = _objectWithoutProperties(_ref2, _excluded2);

  var itemRef = React.useRef();
  React.useEffect(function () {
    if (isFocusedItem) {
      if (ref) {
        ref.current.focus();
      } else {
        itemRef.current.focus();
      }
    }
  }, [isFocusedItem, ref, itemRef]);

  var onKeyDown = function onKeyDown(evt) {
    if (!isDisabled) {
      // enter or space key
      if (evt.keyCode === 13 || evt.keyCode === 32) {
        onClick();
      }
    }
  };

  var handlerOnClick = function handlerOnClick(evt) {
    if (!isDisabled) {
      onClick(evt);
    }
  };

  return /*#__PURE__*/React__default["default"].createElement("li", _extends({
    tabIndex: "-1",
    className: cx__default["default"](className, styles.listItem, _defineProperty({}, styles.listItemDisabled, isDisabled)),
    onKeyDown: onKeyDown,
    onClick: handlerOnClick,
    ref: ref || itemRef
  }, rest), !withCheckbox && showIcon && icon && /*#__PURE__*/React__default["default"].createElement(SVGIcon__default["default"], {
    className: cx__default["default"](iconClass, styles.icon),
    svgRef: icon
  }), withCheckbox && /*#__PURE__*/React__default["default"].createElement("div", {
    "data-testid": "popover-listitem-checkbox"
  }, /*#__PURE__*/React__default["default"].createElement(Checkbox__default["default"], {
    checked: showIcon,
    onChange: handlerOnClick
  })), /*#__PURE__*/React__default["default"].createElement("div", {
    className: cx__default["default"](styles.contentContainer, _defineProperty({}, styles.iconSpace, keepIconSpace && !showIcon && !withCheckbox))
  }, children));
});
PopoverListItem.displayName = "PopoverListItem";
PopoverListItem.propTypes = {
  children: PropTypes__default["default"].oneOfType([PropTypes__default["default"].arrayOf(PropTypes__default["default"].node), PropTypes__default["default"].node]),
  className: PropTypes__default["default"].string,

  /**
   * an svg
   */
  icon: PropTypes__default["default"].object,
  iconClass: PropTypes__default["default"].string,
  isDisabled: PropTypes__default["default"].bool,
  isFocusedItem: PropTypes__default["default"].bool,

  /**
   * To use if other items in the list have an icon but this one does not so all the items remain aligned correctly
   */
  keepIconSpace: PropTypes__default["default"].bool,
  listPrefix: PropTypes__default["default"].node,
  onClick: PropTypes__default["default"].func,
  showIcon: PropTypes__default["default"].bool,

  /**
   * Render the checkbox if true
   */
  withCheckbox: PropTypes__default["default"].bool
};

exports.ListPopover = ListPopover;
exports.PopoverListItem = PopoverListItem;
